/**
 * Format wallet address with dots in the middle
 * @param address - The wallet address to format
 * @returns Formatted address (e.g., "XXXX...XXXX")
 */
export const formatWalletAddress = (address: string): string => {
  if (address.length <= 10) return address;
  const start = address.substring(0, 4);
  const end = address.substring(address.length - 4);
  return `${start}...${end}`;
};
